import { Box, Typography } from '@mui/material';
import React from 'react';

export interface SectionGroupProps {
  title: string;
  lockReason?: string;
  children: React.ReactNode;
}

export const SectionGroup: React.FC<SectionGroupProps> = ({ title, lockReason, children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <Box
      sx={{
        display: 'flex',
        alignItems: 'baseline',
        flexWrap: 'wrap',
        columnGap: 1,
        pb: 0.5,
        borderBottom: '2px solid',
        borderColor: 'divider',
      }}
    >
      <Typography
        sx={{
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: lockReason ? 'text.disabled' : 'text.secondary',
        }}
      >
        {title}
      </Typography>
      {lockReason && (
        <Typography
          sx={{
            fontSize: '11px',
            color: 'text.disabled',
            fontStyle: 'italic',
            textTransform: 'none',
            letterSpacing: 'normal',
          }}
        >
          — {lockReason}
        </Typography>
      )}
    </Box>
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>{children}</Box>
  </Box>
);
